module.exports = __webpack_public_path__ + "img/expovina-primavera_07(1).bdada865.jpg";